import axios from 'axios';
import { AppRunningModeModel } from 'models/Shared/AppRunningModeModel';

export const createApiInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    withCredentials: true,
    ...(process.env.REACT_APP_MODE !== AppRunningModeModel.STAGING
      ? {
          params: {
            fake_email: process.env.REACT_APP_API_USER_NAME,
          },
        }
      : {}),
  });

  instance.interceptors.response.use(
    response => {
      return response.data;
    },
    // error => {
    //   const needAuth = error?.response?.status === 302;
    //   const isUnauthorizedError = error?.response !== undefined && error.response.status === 401;
    //   const enableToAccessToThisHotel =
    //     error?.response !== undefined &&
    //     error.response.status === 403 &&
    //     error.response.data?.invalid_access === true &&
    //     error.response.data?.redirect;

    //   //ERR_NETWORK
    //   if (needAuth || isUnauthorizedError) {
    //     // window.location.href = '/';
    //   }

    //   if (enableToAccessToThisHotel) {
    //     window.location.href = error.response.data?.redirect;
    //   }

    //   return Promise.reject(error);
    // }

    error => {
      const status = error?.response?.status;
      const locationHeader = error?.response?.headers?.location;

      const isRedirectToKeycloak = status === 302 && locationHeader?.includes('keycloak');

      if (isRedirectToKeycloak) {
        window.location.href = locationHeader;
        return;
      }

      if (status === 401) {
        // fallback or logout
        window.location.href = '/';
        return;
      }

      const enableToAccessToThisHotel =
        status === 403 &&
        error.response.data?.invalid_access === true &&
        error.response.data?.redirect;

      if (enableToAccessToThisHotel) {
        window.location.href = error.response.data?.redirect;
        return;
      }

      return Promise.reject(error);
    }
  );

  return instance;
};
